import { Spacing, Text, Title } from '@vkontakte/vkui';
import darkImg from 'img/tooltip/sharing-onboarding-password-dark-tooltip.png';
import lightImg from 'img/tooltip/sharing-onboarding-password-tooltip.png';
import React, { type RefObject, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    PublicPasswordEventCategory,
    sendPublicPasswordAnalytics,
} from 'reactApp/components/SharingWindow/SharingNew/Weblink/PublicPassword/PublicPassword.analytics';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './PasswordOnboardingTooltip.css';

interface PasswordOnboardingTooltipProps {
    target: RefObject<HTMLElement> | Element | null;
    onClose: () => void;
}

export function PasswordOnboardingTooltip({ target, onClose }: PasswordOnboardingTooltipProps) {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const img = isDarkTheme ? darkImg : lightImg;
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    const onTooltipShow = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TOOLTIP_SHOW, { source: 'pswd' });
        sendPublicPasswordAnalytics({ eventCategory: PublicPasswordEventCategory.tooltipPassword, action: 'show', paid_user: isPaidUser });
    }, [isPaidUser]);

    const onTooltipClose = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TOOLTIP_CLOSE, { source: 'pswd' });
        sendPublicPasswordAnalytics({ eventCategory: PublicPasswordEventCategory.tooltipPassword, action: 'close', paid_user: isPaidUser });
        onClose();
    }, [onClose, isPaidUser]);
    return (
        <FloatingTooltip
            contentClassName={styles.root}
            target={target}
            placement={ETooltipPlacement.right}
            qaId="password-onboarding-tooltip"
            withinModal
            closable
            closeOnOutsideClick
            usePortal
            onShow={onTooltipShow}
            onClose={onTooltipClose}
        >
            <div className={styles.tooltip}>
                <Title className={styles.tooltipTitle}>Устанавливайте пароль</Title>
                <Spacing size={4} />
                <Text className={styles.tooltipText}>Скройте от&nbsp;случайных глаз файлы, которыми делитесь в&nbsp;папке</Text>
                <img src={img} alt="Устанавливайте пароль с подпиской Mail Space" className={styles.image} />
            </div>
        </FloatingTooltip>
    );
}
